interface ErrorBannerProps {
  error: string;
  onRetry: () => void;
  onDismiss: () => void;
}

export function ErrorBanner({ error, onRetry, onDismiss }: ErrorBannerProps) {
  return (
    <div className="flex-shrink-0 px-4 py-3 bg-error-100 border-t border-error-500/30">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2 text-sm text-error-700">
          <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
            />
          </svg>
          <span>{error}</span>
        </div>
        <div className="flex items-center gap-2">
          <button
            onClick={onRetry}
            className="px-3 py-1 text-sm bg-error-500 hover:bg-error-700 text-white rounded transition-colors"
          >
            Opnieuw proberen
          </button>
          <button
            onClick={onDismiss}
            className="text-error-500 hover:text-error-700 transition-colors"
          >
            <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
}
